import { render } from "./MandrillLogoIcon.vue?vue&type=template&id=f936c7a8"
import script from "./MandrillLogoIcon.vue?vue&type=script&lang=js"
export * from "./MandrillLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__